import React, { useState, useRef, useEffect } from 'react';

export default function FeatureItem( {item, onClick, checked, group} ) {
    const [showContextMenu, setShowContextMenu] = useState(false);
    const contextMenuRef = useRef(null);
  
    const handleContextMenu = (e) => {
      e.preventDefault();
      setShowContextMenu(true);
    };
  
    const handleClickOutside = (e) => {
      if (contextMenuRef.current && !contextMenuRef.current.contains(e.target)) {
        setShowContextMenu(false);
      }
    };
  
    useEffect(() => {
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }, []);

    return (
        <>
        {group ? (
            <div className="flex items-center h-32 px-2">
                <span className="text-gray-800 uppercase font-semibold tracking-wide text-md">{item.label}</span>
            </div>
        )
        :
        (
        <div
        className="flex items-center h-24 hover:bg-purple-100" 
	      onClick={onClick}
        onContextMenu={handleContextMenu} 
        style={{
            position: 'relative',
        }}
        >
            <input type="checkbox" className="form-checkbox mx-2 h-4 w-4" defaultChecked={checked} />
            <span className="text-md text-gray-700">{item.label}</span>
            {showContextMenu && (
                <div ref={contextMenuRef} className="absolute z-10 bg-white shadow-lg border border-gray-200 rounded-md p-2 mt-2">
                    <button
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    onClick={() => { item.onInspect(item.queryId); setShowContextMenu(false); }}
                    >Inspect Feature</button>
                </div>
            )}
        </div>
        )
        }
        </>
    )
}
